import React from 'react';
import logoCooperfibra from 'assets/images/logo-cooper-mini.png';
import { MainNavigator } from './MainNavigator';
import { mainNavOptions } from 'data/mainNavOptions';
import TopPanel from './TopPanel';
import * as S from './styles';
import { useAuth } from 'hooks/auth';

interface Props extends React.PropsWithChildren<{}> {}

export const Scaffold: React.FC<Props> = ({ children }) => {
  const { userBelongsToAnyOf } = useAuth();

  const userPermissions = [];

  if (userBelongsToAnyOf('admin')) {
    userPermissions.push('estoque');
    userPermissions.push('agendamento');
    userPermissions.push('configuracoes');
  } else if (userBelongsToAnyOf('carrierMember')) {
    userPermissions.push('agendamento');
  } else if (userBelongsToAnyOf('warehouseMember')) {
    userPermissions.push('estoque');
    userPermissions.push('agendamento');
  } else if (userBelongsToAnyOf('companyMember')) {
    userPermissions.push('estoque');
    userPermissions.push('agendamento');
  }

  return (
    <S.PageContainer>
      <S.Backdrop>
        <S.MainContainer>
          <S.LeftPanelSlot>
            {/* <LeftPanel key={'@left-panel'}/> */}
            <MainNavigator
              options={mainNavOptions}
              userPermissions={userPermissions}
              clientLogo={logoCooperfibra}
            />
          </S.LeftPanelSlot>
          <S.MainSlot>
            <TopPanel />
            <S.ChildrenSlot>{children}</S.ChildrenSlot>
          </S.MainSlot>
        </S.MainContainer>
      </S.Backdrop>
    </S.PageContainer>
  );
};
